<template>
  <!-- The Kode AI mark, traced from its icon (1050 × 1066): the "k" — a
       periwinkle stem and the paler chevron beside it — and two four-point
       sparkles, white fading to lavender. It is transparent: the icon's navy
       is whatever it sits on. `fit` frames it: "icon" keeps the icon's own
       margins with the letter centred, as designed (the button, the header,
       the hello); "tight" crops in on the whole mark, for small sizes (the
       answers' avatar). `twinkle` sets the sparkles pulsing while Kode
       thinks. -->
  <svg
    class="kai-logo"
    :class="{ 'is-twinkling': twinkle }"
    :viewBox="fit === 'tight' ? TIGHT_VIEW_BOX : ICON_VIEW_BOX"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <!-- Per sparkle, corner to corner: white at the top left, lavender at the bottom right. -->
      <linearGradient :id="sparkleId" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#FFFFFF" />
        <stop offset="1" stop-color="#B7C2EF" />
      </linearGradient>
    </defs>
    <rect x="372.5" y="302.5" width="74" height="460" fill="#7A93CC" />
    <path d="M588.5 453.5H676.5L552.5 607L676.5 760.5H588.5L463.5 607Z" fill="#A5B4DF" />
    <path
      class="kai-logo__sparkle kai-logo__sparkle--big"
      :fill="`url(#${sparkleId})`"
      d="M784.4 273C784.4 323.1 820.7 359.4 870.8 359.4C820.7 359.4 784.4 395.7 784.4 445.8C784.4 395.7 748.1 359.4 698 359.4C748.1 359.4 784.4 323.1 784.4 273Z"
    />
    <path
      class="kai-logo__sparkle kai-logo__sparkle--small"
      :fill="`url(#${sparkleId})`"
      d="M844.4 443.7C844.4 465.1 858.6 479.3 880 479.3C858.6 479.3 844.4 493.5 844.4 514.9C844.4 493.5 830.2 479.3 808.8 479.3C830.2 479.3 844.4 465.1 844.4 443.7Z"
    />
  </svg>
</template>
<script>
// The icon's square, centred on the "k" as the icon centres it.
const ICON_VIEW_BOX = '-8.5 -0.5 1066 1066';
// A square around the whole mark (the "k" and its sparkles), with a little room.
const TIGHT_VIEW_BOX = '256.25 147.75 740 740';

// Each mark draws its own gradient: one id shared by several would make all
// of them use the first, which a hidden panel would leave unpainted.
let nextId = 0;

export default {
  name: 'KodeAiLogo',
  props: {
    fit: {
      type: String,
      default: 'icon',
      validator: (value) => ['icon', 'tight'].includes(value),
    },
    twinkle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    nextId += 1;
    return {
      sparkleId: `kai-logo-sparkle-${nextId}`,
      ICON_VIEW_BOX,
      TIGHT_VIEW_BOX,
    };
  },
};
</script>
<style scoped>
.kai-logo {
  display: block;
  width: 100%;
  height: 100%;
  overflow: visible;
}

/* Each sparkle turns and scales about its own centre. */
.kai-logo__sparkle {
  transform-box: fill-box;
  transform-origin: center;
  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.kai-logo.is-twinkling .kai-logo__sparkle--big {
  animation: kai-logo-twinkle 1.6s ease-in-out infinite;
}

.kai-logo.is-twinkling .kai-logo__sparkle--small {
  animation: kai-logo-twinkle 1.6s ease-in-out 0.45s infinite;
}

@keyframes kai-logo-twinkle {
  0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; }
  50% { transform: scale(0.7) rotate(45deg); opacity: 0.7; }
}

@media (prefers-reduced-motion: reduce) {
  .kai-logo__sparkle {
    transition: none;
  }

  .kai-logo.is-twinkling .kai-logo__sparkle--big,
  .kai-logo.is-twinkling .kai-logo__sparkle--small {
    animation: none;
  }
}
</style>
